import styled from "styled-components";

export const Root = styled.div`
  width: 100%;
  padding: 48px 24px;

  @media (min-width: 1024px) {
    padding: 72px 32px;
  }

  @media (min-width: 1400px) {
    padding: 72px 48px;
  }
`;

export const Container = styled.div`
  max-width: 1304px;
  margin: 0 auto;
`;

export const PageTitle = styled.h1`
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 40px;
  text-transform: uppercase;
`;

export const AttendeesSection = styled.div`
  margin-bottom: 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const AttendeeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding: 20px 0;
  background: transparent;
  border-radius: 4px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const AttendeeReadOnly = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  padding: 16px 20px;
  background: #ffffff;
  border: 1px solid #dbdfea;
  border-radius: 4px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const AttendeeInfo = styled.div`
  flex: 1;
  font-size: 14px;
  color: #2c2f3e;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: #8f95a5;
  cursor: pointer;
  padding: 4px 8px;
  font-size: 20px;
  line-height: 1;
  transition: color 0.2s;

  &:hover {
    color: #e1000f;
  }
`;

export const AttendeeFields = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
  flex: 1;
  position: relative;
  width: 100%;
  max-width: 734px;
  min-height: 38px;
  border-radius: 4px;
  border: 1px solid #dbdfea;
  opacity: 1;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const InputField = styled.input`
  padding: 12px 16px;
  border: 1px solid ${props => props.error ? '#e1000f' : '#9A98A0'};
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
  background: transparent;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #e1000f;
  }

  &::placeholder {
    color: #8f95a5;
  }
`;

export const PointsLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #2c2f3e;
  white-space: nowrap;
  min-width: 100px;
  text-align: right;

  @media (max-width: 768px) {
    text-align: left;
    min-width: auto;
  }
`;

export const ErrorMessage = styled.div`
  color: #e1000f;
  font-size: 12px;
  margin-top: 4px;
`;

export const InsufficientPointsMessage = styled.div`
  margin-bottom: 24px;
`;

export const NotEnoughPointsLabel = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 4px 0;
  color: #e1000f;
  font-family: Yellix, sans-serif;
  font-weight: 700;
  font-size: 17px;
  line-height: 25px;
`;

export const BookingPrompt = styled.p`
  margin: 0;
  font-size: 14px;
  color: #2c2f3e;

  a {
    color: #e1000f;
    font-weight: 700;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const AddMoreSection = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  margin-bottom: 24px;
  background: none;
  color: ${(props) => (props.disabled ? "#8f95a5" : "#2c2f3e")};
  border: none;
  font-size: 14px;
  font-weight: 700;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: color 0.2s;

  &:hover {
    color: ${(props) => (props.disabled ? "#8f95a5" : "#e1000f")};
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 5px;
  right: 0;
  background: none;
  border: none;
  color: #8f95a5;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  z-index: 1;

  &:hover {
    color: #e1000f;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const TotalSection = styled.div`
  margin: 40px 0;
  padding-top: 24px;
  border-top: 2px solid #dbdfea;
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  font-size: 24px;
  font-weight: 700;
  color: ${props => props.muted ? '#8f95a5' : '#2c2f3e'};
`;

export const ContinueButton = styled.button`
  width: 262px;
  height: 32px;
  padding: 2px 16px 2px 20px;
  background: ${props => props.disabled ? '#dbdfea' : '#e1000f'};
  color: #ffffff;
  border: none;
  border-radius: 16.46px;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  opacity: 1;
  box-sizing: border-box;

  &:hover {
    background: ${props => props.disabled ? '#dbdfea' : '#c00000'};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const BackLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #8f95a5;
  text-decoration: none;
  font-size: 14px;
  margin-top: 24px;
  cursor: pointer;

  &:hover {
    color: #2c2f3e;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;
